// extracted by mini-css-extract-plugin
export default {"cls1":"NV_EtBI5gbq63ixbUBZZ","cls2":"mFue6apbAqdhZ4nxudf6 NV_EtBI5gbq63ixbUBZZ"};